import React, { useRef, useState } from "react"

import classNames from "@utils/classnames"

import * as styles from "./nav.module.scss"
import config from "@config"
import Clickable from "../clickable"
import Icon from "../icon"
import { useScrollEvent } from "@src/utils/hooks/common"

const ITEMS = [
  {
    key: "news",
    title: "最新资讯",
  },
  {
    key: "intro",
    title: "活动介绍",
  },
  {
    key: "play",
    title: "玩法",
  },
  {
    key: "guests",
    title: "嘉宾",
  },
  {
    key: "stage",
    title: "舞台",
  },
  {
    key: "sales",
    title: "现场贩售",
  },
  {
    key: "ticket",
    title: "立即购票",
    url: config.data.ticketUrl,
    bg: true,
  },
]

const Nav = ({ location }) => {
  const [dropdownVisble, setDropdownVisible] = useState(false)
  const [visible, setVisible] = useState(true)
  const prevScrollTopRef = useRef()

  useScrollEvent(() => {
    const scrollTop = window.scrollY
    const prevTop = prevScrollTopRef.current
    if (scrollTop <= 500) {
      setVisible(true)
      return
    }
    if (prevTop >= 0) {
      setVisible(scrollTop < prevTop)
    }
    prevScrollTopRef.current = scrollTop
  })

  const handleItemClick = (e) => {
    setDropdownVisible(false)

    const t = e.currentTarget
    const id = t.getAttribute("href")
    const elem = document.querySelector(`#${id.split("#")[1]}`)

    if (!elem) {
      return
    }

    const headerOffset = 50
    const elementPosition = elem.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })

    e.preventDefault()
  }

  return (
    <nav
      className={classNames(styles.nav, {
        [styles.isDropdown]: dropdownVisble,
        [styles.isHide]: !visible,
      })}
    >
      <Clickable
        className={styles.dropDownMask}
        onClick={() => {
          setDropdownVisible(false)
        }}
      />
      <div>
        <div className={styles.logoContainer}>
          <Icon icon="gcores" className={styles.logo} />
        </div>
        <div className={styles.right}>
          <Clickable
            className={styles.menuBtn}
            onClick={() => {
              setDropdownVisible((prev) => !prev)
            }}
          >
            {dropdownVisble ? <Icon icon="burger" /> : <Icon icon="burger" />}
          </Clickable>
          <div className={styles.menu}>
            <ul>
              {ITEMS.map(({ title, key, url, bg }) => {
                return (
                  <li key={title}>
                    <Clickable
                      newWindow={false}
                      href={url ? undefined : `#${key}`}
                      appNavTo={url}
                      onClick={handleItemClick}
                      className={bg ? styles.itemBg : undefined}
                    >
                      {title}
                    </Clickable>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Nav
